import { useState } from "react";
import { Link } from "react-router-dom";
import SectionHeading from "@/components/base/SectionHeading";
import { faqs } from "@/mocks/news";

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const homeFaqs = faqs.slice(0, 4);

  const toggle = (index: number) => {
    setOpenIndex((current) => (current === index ? null : index));
  };

  return (
    <section id="faq" className="mx-auto max-w-content scroll-mt-32 px-4 pt-16 md:px-6 md:pt-20">
      <div className="grid grid-cols-1 gap-10 lg:grid-cols-12">
        <div className="lg:col-span-4">
          <SectionHeading
            eyebrow="FAQ"
            title="常见问题"
            description="关于内容来源、更新频率和我们坚持的原则，这里一次性说清楚。"
          />
          <Link
            to="/faq"
            className="mt-6 inline-flex items-center gap-1.5 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-4 py-2.5 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-700"
          >
            查看全部问题
            <i className="ri-arrow-right-line" aria-hidden="true" />
          </Link>
        </div>

        <div className="lg:col-span-8">
          <div className="divide-y divide-background-200 overflow-hidden rounded-lg border border-background-200 bg-background-50">
            {homeFaqs.map((faq, index) => {
              const isOpen = openIndex === index;
              return (
                <div key={faq.q}>
                  <h3>
                    <button
                      type="button"
                      onClick={() => toggle(index)}
                      aria-expanded={isOpen}
                      className="flex w-full cursor-pointer items-center justify-between gap-4 px-5 py-4 text-left transition-colors hover:bg-background-100 md:px-6"
                    >
                      <span className="font-heading text-sm font-bold text-foreground-900 md:text-base">
                        {faq.q}
                      </span>
                      <span
                        className={`flex h-6 w-6 shrink-0 items-center justify-center rounded-full border transition-colors ${
                          isOpen
                            ? "border-primary-500 bg-primary-500 text-background-50"
                            : "border-background-300 text-foreground-500"
                        }`}
                      >
                        <i
                          className={isOpen ? "ri-subtract-line text-sm" : "ri-add-line text-sm"}
                          aria-hidden="true"
                        />
                      </span>
                    </button>
                  </h3>
                  {isOpen ? (
                    <div className="px-5 pb-5 md:px-6">
                      <p className="text-sm leading-relaxed text-foreground-600">{faq.a}</p>
                    </div>
                  ) : null}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}